export default __webpack_public_path__ + "static/media/git.8e0be201.png";